module.exports = __webpack_public_path__ + "img/tyh3.283f2993.jpg";